import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

const ROLES = ["teacher", "principal", "accountant", "hr", "admin"];
const initials = (n) => (n || "?").split(" ").map((x) => x[0]).slice(0, 2).join("").toUpperCase();

export default function StaffPage() {
  const [users, setUsers] = useState([]);
  const [tab, setTab] = useState("teacher");

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/users");
      setUsers(data);
    })();
  }, []);

  const grouped = ROLES.map((r) => ({ role: r, users: users.filter((u) => u.role === r) }));

  return (
    <div className="space-y-6" data-testid="staff-page">
      <div>
        <div className="text-[0.65rem] tracking-[0.2em] uppercase text-muted-foreground">People</div>
        <h1 className="text-4xl font-bold tracking-tight">Staff directory</h1>
        <p className="text-muted-foreground text-sm mt-1">Filter by role. Total {users.filter((u) => u.role !== "student" && u.role !== "parent").length} staff members.</p>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="rounded-2xl">
          {ROLES.map((r) => (
            <TabsTrigger key={r} value={r} className="rounded-xl capitalize" data-testid={`staff-tab-${r}`}>{r}</TabsTrigger>
          ))}
        </TabsList>
        {grouped.map((g) => (
          <TabsContent key={g.role} value={g.role} className="mt-4">
            <Card className="rounded-2xl">
              <CardHeader>
                <CardTitle className="text-base capitalize">{g.role}s</CardTitle>
              </CardHeader>
              <CardContent className="divide-y divide-border/60">
                {g.users.length === 0 ? (
                  <div className="py-8 text-center text-sm text-muted-foreground">No {g.role}s yet.</div>
                ) : (
                  g.users.map((u) => (
                    <div key={u.id} className="py-3 flex items-center gap-4">
                      <Avatar className="h-10 w-10">
                        <AvatarFallback className="bg-primary/15 text-primary text-xs">{initials(u.name)}</AvatarFallback>
                      </Avatar>
                      <div className="flex-1 min-w-0">
                        <div className="font-medium truncate">{u.name}</div>
                        <div className="text-xs text-muted-foreground truncate">{u.email}</div>
                      </div>
                      <Badge variant="outline" className="rounded-full capitalize">{u.role}</Badge>
                    </div>
                  ))
                )}
              </CardContent>
            </Card>
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
